import CSS from "csstype"
import React from "react"
import { isDuoMode } from "../../../../../config"
import { useAppSelector } from "../../../hooks"
import GamePlayer from "./game-player"

const style: CSS.Properties = {
  position: "absolute",
  height: "100%",
  width: "70px",
  right: "0.5%",
  top: "4px"
}

export default function GamePlayers(props: { click: (id: string) => void }) {
  const players = useAppSelector((state) => state.game.players)
  const gameMode = useAppSelector((state) => state.game.gameMode)
  const selfPlayerId = useAppSelector((state) => state.network.uid)
  const isDuo = isDuoMode(gameMode)

  // Compute team HP map
  const teamHpMap = new Map<string, number>()
  if (isDuo) {
    for (const p of players) {
      if (p.teamId) {
        teamHpMap.set(p.teamId, (teamHpMap.get(p.teamId) ?? 0) + p.life)
      }
    }
  }

  // Sort: by rank, but in duo mode keep teammates adjacent
  const sortedPlayers = [...players].sort((a, b) => {
    if (isDuo && a.teamId && b.teamId) {
      const teamRankA = Math.min(...players.filter(p => p.teamId === a.teamId).map(p => p.rank))
      const teamRankB = Math.min(...players.filter(p => p.teamId === b.teamId).map(p => p.rank))
      if (teamRankA !== teamRankB) return teamRankA - teamRankB
      if (a.teamId === b.teamId) return 0
    }
    return a.rank - b.rank
  })

  const myTeamId = players.find(p => p.id === selfPlayerId)?.teamId

  // Build a map from each player to their teammate's avatar
  const teammateAvatarMap = new Map<string, string>()
  if (isDuo) {
    for (const p of players) {
      if (p.teamId) {
        const mate = players.find(m => m.teamId === p.teamId && m.id !== p.id)
        if (mate) teammateAvatarMap.set(p.id, mate.avatar)
      }
    }
  }

  return (
    <div style={style}>
      {sortedPlayers.map((p, i) => {
        return (
          <GamePlayer
            key={p.id}
            player={p}
            click={(id: string) => props.click(id)}
            index={i}
            teamHp={isDuo && p.teamId ? teamHpMap.get(p.teamId) : undefined}
            isTeammate={isDuo && !!myTeamId && p.teamId === myTeamId && p.id !== selfPlayerId}
            teammateAvatar={isDuo ? teammateAvatarMap.get(p.id) : undefined}
          />
        )
      })}
    </div>
  )
}
